import { ExternalMobileDashboardComponent } from './external-mobile-dashboard.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const externalMobileDashboardRoutes: Routes = [
  {
    path: 'external-mobile-dashboard',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'MOBILE_DASHBOARD',
        redirectTo: '/',
      },
    },
    children: [{ path: '', component: ExternalMobileDashboardComponent }],
  },
]
